import React, {createContext, useEffect, useState} from "react"
import fclConfig from "src/fclConfig"

interface RuntimeConfig {
  contractFungibleToken: string
  contractFlowToken: string
  contractFUSD: string
  contractFCLCrypto: string
  flowAccountAddress: string
  flowAccountPrivateKey: string
  flowAccountPublicKey: string
  flowAccountKeyId: string
  flowAccessNode: string
}

interface StaticConfig {
  avatarUrl: string
  flowInitAccountsNo: number
  tokenAmountFLOW: string
  tokenAmountFUSD: string
}

const defaultConfig = {
  contractFungibleToken: process.env.contractFungibleToken || "",
  contractFlowToken: process.env.contractFlowToken || "",
  contractFUSD: process.env.contractFUSD || "",
  contractFCLCrypto: process.env.contractFCLCrypto || "",
  flowAccountAddress: process.env.flowAccountAddress || "",
  flowAccountPrivateKey: process.env.flowAccountPrivateKey || "",
  flowAccountPublicKey: process.env.flowAccountPublicKey || "",
  flowAccountKeyId: process.env.flowAccountKeyId || "",
  flowAccessNode: process.env.flowAccessNode || "",
}

export const ConfigContext = createContext<RuntimeConfig>(defaultConfig)

export function getStaticConfig(): StaticConfig {
  // Should we set sensible defaults here?
  return {
    avatarUrl: process.env.avatarUrl || "",
    flowInitAccountsNo: parseInt(process.env.flowInitAccountsNo || "0") || 0,
    tokenAmountFLOW: process.env.tokenAmountFLOW || "",
    tokenAmountFUSD: process.env.tokenAmountFUSD || "",
  }
}

async function getConfig(): Promise<RuntimeConfig> {
  return defaultConfig
}

export function ConfigContextProvider({children}: {children: React.ReactNode}) {
  const [config, setConfig] = useState<RuntimeConfig>()

  useEffect(() => {
    async function fetchConfig() {
      const config = await getConfig()

      const {
        flowAccessNode,
        flowAccountAddress,
        contractFungibleToken,
        contractFlowToken,
        contractFUSD,
      } = config

      fclConfig(
        flowAccessNode,
        flowAccountAddress,
        contractFungibleToken,
        contractFlowToken,
        contractFUSD
      )

      setConfig(config)
    }

    fetchConfig()
  }, [])

  if (!config) return null

  return (
    <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
  )
}
